export default {
  passwordReset: {
    heading: 'Reset Password',
    submitButton: 'Reset password',
    form: {
      password: 'Password',
      passwordConfirmation: 'Password confirmation',
    },
    formSuccessMessage: 'Your password was successfully changed!',
    formErrorMessage: 'There is an error in the form. Please review it.',
  },
}
